// Subscribes the email in a [data-klaviyo-signup] form to a Klaviyo list straight from the browser
// (Klaviyo "Client API", public company ID + list ID only). The form keeps its normal Shopify
// action as the no-JS fallback. Data attributes: data-company, data-list, data-source, data-success (message),
// data-success-class / data-error-class (message styling).
(function () {
  var REVISION = '2024-10-15';

  function post(form, email) {
    var company = form.getAttribute('data-company');
    var list = form.getAttribute('data-list');
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: form.getAttribute('data-source') || 'Website sign-up',
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo ' + res.status);
    });
  }

  function init(form) {
    if (!form.getAttribute('data-company') || !form.getAttribute('data-list')) return;
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    if (!input) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var existing = form.querySelector('[data-klaviyo-message]');
      if (existing) existing.remove();
      var email = input.value.trim();
      if (!email || !input.checkValidity()) {
        input.reportValidity();
        return;
      }
      if (button) button.disabled = true;

      post(form, email)
        .then(function () {
          var done = document.createElement('p');
          done.className = 'lv-body-base lv-cc__success';
          done.textContent = form.getAttribute('data-success') || 'Thank you — welcome to the Collector’s Club.';
          // Replace the whole form contents (row, consent line) with the confirmation.
          while (form.firstChild) form.removeChild(form.firstChild);
          form.appendChild(done);
        })
        .catch(function () {
          if (button) button.disabled = false;
          var err = document.createElement('p');
          err.className = form.getAttribute('data-error-class') || 'lv-body-small lv-cc__error';
          err.setAttribute('data-klaviyo-message', '');
          err.setAttribute('role', 'alert');
          err.textContent = 'Sorry, something went wrong. Please try again in a moment.';
          form.appendChild(err);
        });
    });
  }

  document.querySelectorAll('form[data-klaviyo-signup]').forEach(init);
})();
